import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import { HiOutlineRocketLaunch } from "react-icons/hi2";
import "./yetToCome.css";

function YetToCome() {
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="ytc-container">
        <div className="ytc-card">
          <div className="ytc-icon">
            <HiOutlineRocketLaunch />
          </div>

          <h1 className="ytc-title">Feature Launching Soon</h1>

          <p className="ytc-text">
            Our team is actively building this feature to deliver a seamless experience for you.
            Stay tuned for updates.
          </p>
        </div>
      </div>

      <Footer />
    </DashboardLayout>
  );
}

export default YetToCome;